<template>
  <div ref="sentinela" class="sentinela-rolagem" aria-hidden="true"></div>
</template>

<script>
export default {
  name: "sentinelaRolagemInfinita",
  props: {
    ativo: Boolean,
    carregando: Boolean,
    margem: {
      type: String,
      default: "240px",
    },
  },
  data() {
    return {
      observador: null,
      estaVisivel: false,
    };
  },
  watch: {
    ativo() {
      this.emitirSeNecessario();
    },
    carregando(valor) {
      if (!valor) {
        this.$nextTick(this.emitirSeNecessario);
      }
    },
  },
  mounted() {
    if (typeof IntersectionObserver === "undefined") {
      window.addEventListener("scroll", this.verificarPosicao);
      this.verificarPosicao();
      return;
    }

    this.observador = new IntersectionObserver(this.aoObservar, {
      rootMargin: `0px 0px ${this.margem} 0px`,
      threshold: 0,
    });
    this.observador.observe(this.$refs.sentinela);
  },
  beforeDestroy() {
    if (this.observador) {
      this.observador.disconnect();
    }
    window.removeEventListener("scroll", this.verificarPosicao);
  },
  methods: {
    aoObservar(entradas) {
      this.estaVisivel = entradas.some((entrada) => entrada.isIntersecting);
      this.emitirSeNecessario();
    },
    verificarPosicao() {
      if (!this.$refs.sentinela) {
        return;
      }

      const limite = window.innerHeight + 240;
      this.estaVisivel = this.$refs.sentinela.getBoundingClientRect().top <= limite;
      this.emitirSeNecessario();
    },
    emitirSeNecessario() {
      if (this.ativo && !this.carregando && this.estaVisivel) {
        this.$emit("visivel");
      }
    },
  },
};
</script>

<style scoped>
.sentinela-rolagem {
  height: 1px;
  width: 100%;
}
</style>
